import React, {FC} from "react"
import {Col} from "react-bootstrap"
import styled from "styled-components"

import {getActiveProducts} from "@irati/products/utils/products"
import {H3} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import idHelper from "@irati/utils/id"

import {SectionHeader} from "../styled"
import HomePageRow from "../HomePageRow"
import {HomePageView} from "../types"
import ProductTile from "./Product"
import authentication from "@irati/auth"

interface Props {
  id: string
  isOnHover?: boolean
  pageView: HomePageView
  alignOverlayToBottom?: boolean
}

interface StyledProps {
  alignOverlayToBottom?: boolean
}

const Overlay = styled.div<StyledProps>`
  background-color: ${({theme}) => theme.colors.greys.dark};
  opacity: 0.6;
  width: 100vw;
  height: ${({alignOverlayToBottom}) => (alignOverlayToBottom ? "100%" : "150%")};
  position: absolute;
  left: 50%;
  right: 50%;
  top: ${({alignOverlayToBottom}) => (alignOverlayToBottom ? "0" : "-50%")};
  margin-left: -50vw;
  margin-right: -50vw;
`

const TenantProducts: FC<Props> = (props) => {
  // Show TenantProducts just if we're hiding homepage lanes (Business FeatureFlag)
  const showTenantProducts = authentication.apps("platform.homepageLanesHidden")
  if (!showTenantProducts) {
    return null
  }
  const {pageView, alignOverlayToBottom} = props
  const id = idHelper("tenant-products", props)
  const activeProducts = getActiveProducts()

  return (
    <HomePageRow id={id}>
      <Col xs={12}>
        <SectionHeader>
          <H3>
            <FormattedMessage id="platform.homepage.products.title" />
          </H3>
        </SectionHeader>
        <div>
          {activeProducts.map((product, i) => (
            <ProductTile id={id} key={product.product} product={product} isLast={i === activeProducts.length - 1} />
          ))}
        </div>
      </Col>
      {pageView === HomePageView.EDIT_CONTENT_VIEW && <Overlay alignOverlayToBottom={alignOverlayToBottom} />}
    </HomePageRow>
  )
}

export default TenantProducts
